/**
 * ============================================================================
 *                              crmss 版权声明
 * ============================================================================
 * 本软件系统（crmss - 快速开发通用管理后台框架）所有代码版权归 crmss 团队所有。
 * 代码中的 crmss 版权声明不允许删除和修改。
 * ============================================================================
 */
<template>
  <router-view v-slot="{ Component }">
    <transition name="fade-transform" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script setup lang="ts">
/**
 * crmss 根组件
 * 应用入口组件，提供全局布局和过渡动画
 * 
 * @author crmss Team
 * @version 1.0.0
 */
import { onMounted } from 'vue'
import { useUserStore } from '@/stores/user'
import { isValidJwtFormat } from '@/utils/jwt-check'

// crmss 系统信息
const crmssInfo = {
  name: '睿美经营宝品牌管理',
  version: '1.0.0',
  copyright: 'crmss Team'
}

const userStore = useUserStore()

onMounted(async () => {
  // 初始化用户信息（从 Cookie 恢复）
  userStore.initUserInfo()

  // 如果已登录，先校验 token 是合法 JWT 格式（含两个 '.'），
  // 防止 Cookie 拋留 "null" / "undefined" / 损坏字符串被当成 token 发给后端
  if (userStore.isLoggedIn) {
    if (!isValidJwtFormat(userStore.token)) {
      console.warn('[crmss] Cookie 中的 token 不是合法 JWT 格式，清空并跳登录页')
      userStore.clearToken()
      location.href = '/login'
      return
    }
    await userStore.getUserInfo()
  }
})
</script>

<style lang="scss">
// crmss 全局过渡动画
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>
